import React, { Suspense } from "react";
import { Navigate } from "react-router-dom";
import LoaderSuspense from "../components/common/LoaderSuspense";
import { ProtectedRoutes, RedirectAuthRoute, RedirectPageNotAvailable } from "./routerUtils";
import { UserType } from "../utils/api/user/user.type";

const Loader = (Component) => (props) =>
(
  <Suspense fallback={<LoaderSuspense />}>
    <Component {...props} />
  </Suspense>
);

// Toutes les pages en lazy loading
const HomePage = Loader(React.lazy(() => import("../components/HomePage/HomePage")));
const ParcoursAchat = Loader(React.lazy(() => import("../components/user/ParcoursAchat/ParcoursAchat")));
const MentionLegale = Loader(React.lazy(() => import("../components/shared/FooterPage/MentionLegale")));
const ProduitItemPage = Loader(React.lazy(() => import("../components/user/ParcoursAchat/ProduitItemPage")));
const CguPage = Loader(React.lazy(() => import("../components/shared/FooterPage/Cgu")));
const ForgetPassword = Loader(React.lazy(() => import("../components/auth/ForgetPassword")));
const OurProduct = Loader(React.lazy(() => import("../components/Product/OurProduct")));
const PanierPage = Loader(React.lazy(() => import("../components/MonCompte/MonComptePage/Panier/PanierPage")));
const PolitiqueConfidentialite = Loader(React.lazy(() => import("../components/front/politiqueConfidentialite/PolitiqueConfidentialite")));
const Contact = Loader(React.lazy(() => import("../components/front/contact/Contact")));
const WhoWeAre = Loader(React.lazy(() => import("../components/front/whoWeAre/WhoWeAre")));
const MonCompteLayout = Loader(React.lazy(() => import("../components/MonCompte/MonCompteLayout")));
const ProfilPage = Loader(React.lazy(() => import("../components/MonCompte/MonComptePage/ProfilPage")));
const CommandePage = Loader(React.lazy(() => import("../components/MonCompte/MonComptePage/Commande/CommandePage")));
const CommandeDetail = Loader(React.lazy(() => import("../components/MonCompte/MonComptePage/Commande/CommandeDetail")));
const FavorisPage = Loader(React.lazy(() => import("../components/MonCompte/MonComptePage/FavorisPage")));
const ValidateCommand = Loader(React.lazy(() => import("../components/MonCompte/MonComptePage/validateCommand/ValidateCommand")));
const CGV = Loader(React.lazy(() => import("../components/front/cgv/CGV")));
const SuccessPaiement = Loader(React.lazy(() => import("../components/MonCompte/MonComptePage/validateCommand/SuccessPaiement")));
const OrderItem = Loader(React.lazy(() => import("../components/MonCompte/MonComptePage/OrderItem")));
const ResetPassword = Loader(React.lazy(() => import("../components/auth/ResetPassword")));
const PagesError404 = Loader(React.lazy(() => import("../components/shared/PagesError404")));
const PageNotAvailable = Loader(React.lazy(() => import("../components/shared/PageNotAvailable")));


export const AppRoutes = [
  {
    path: "/",
    element: (
      <RedirectPageNotAvailable>
        <HomePage />
      </RedirectPageNotAvailable>
    ),
  },
  {
    path: "/mot-de-passe-oublie",
    element: (
      <RedirectAuthRoute>
        <ForgetPassword />
      </RedirectAuthRoute>
    ),
  },
  {
    path: "/modifier-mot-de-passe",
    element: (
      <RedirectAuthRoute>
        <ResetPassword />
      </RedirectAuthRoute>
    ),
  },
  {
    path: "/achats",
    element: (
      <RedirectPageNotAvailable>
        <ParcoursAchat />
      </RedirectPageNotAvailable>
    ),
  },
  {
    path: "/mentions-legales",
    element: (
      <RedirectPageNotAvailable>
        <MentionLegale />
      </RedirectPageNotAvailable>
    ),
  },
  {
    path: "/cgu",
    element: (
      <RedirectPageNotAvailable>
        <CguPage />
      </RedirectPageNotAvailable>
    ),
  },
  {
    path: "/produit/:slug",
    element: (
      <RedirectPageNotAvailable>
        <ProduitItemPage />
      </RedirectPageNotAvailable>
    ),
  },
  // {
  //   path: "/valider-commande",
  //   element: <ValidateCommand />,
  // },
  {
    path: "/commande-details",
    element: (
      <RedirectPageNotAvailable>
        <OrderItem />
      </RedirectPageNotAvailable>
    ),
  },
  {
    path: "/produits",
    element: (
      <RedirectPageNotAvailable>
        <OurProduct />
      </RedirectPageNotAvailable>
    ),
  },
  {
    path: "politique-de-confidentialite",
    element: (
      <RedirectPageNotAvailable>
        <PolitiqueConfidentialite />
      </RedirectPageNotAvailable>
    ),
  },
  {
    path: "conditions-generales-de-ventes",
    element: (
      <RedirectPageNotAvailable>
        <CGV />
      </RedirectPageNotAvailable>
    ),
  },
  {
    path: "contact",
    element: (
      <RedirectPageNotAvailable>
        <Contact />
      </RedirectPageNotAvailable>
    ),
  },
  {
    path: "a-propos-de-nous",
    element: (
      <RedirectPageNotAvailable>
        <WhoWeAre />
      </RedirectPageNotAvailable>
    ),
  },
  {
    path: "site-non-disponible",
    element: <PageNotAvailable />,
  },
  {
    path: "/paiement",
    element: (
      <RedirectPageNotAvailable>
        <SuccessPaiement />
      </RedirectPageNotAvailable>
    ),
  },
  {
    path: "mon-compte",
    element: (
      <RedirectPageNotAvailable>
        <MonCompteLayout />
      </RedirectPageNotAvailable>
    ),
    children: [
      { element: <Navigate to="/mon-compte/profil" replace />, index: true },
      {
        path: "profil",
        element: (
          // <ProtectedRoutes
          //   userType={[UserType.admin, UserType.acheteur, UserType.vendeur]}
          // >
          <ProfilPage />
          // </ProtectedRoutes>
        ),
      },
      {
        path: "commandes",
        element: (
          <ProtectedRoutes
            userType={[UserType.admin, UserType.acheteur, UserType.vendeur]}
          >
            <CommandePage />
          </ProtectedRoutes>
        ),
      },
      {
        path: "commandes/:slug",
        element: (
          <ProtectedRoutes
            userType={[UserType.admin, UserType.acheteur, UserType.vendeur]}
          >
            <CommandeDetail />
          </ProtectedRoutes>
        ),
      },
      {
        path: "panier",
        element: <PanierPage />,
      },
      {
        path: "favoris",
        element: (
          <ProtectedRoutes
            userType={[UserType.admin, UserType.acheteur, UserType.vendeur]}
          >
            <FavorisPage />
          </ProtectedRoutes>
        ),
      },
    ],
  },
  {
    path: "/panier",
    element: (
      <RedirectPageNotAvailable>
        <ValidateCommand />
      </RedirectPageNotAvailable>
    ),
  },
  {
    path: "*",
    element: <PagesError404 />,
  },
];